import { put, takeLatest, fork, call } from "redux-saga/effects";

import {
  ActionType,
  DataDestinationResponse,
} from "models/bodyTemperature/destinations";
import { httpStatus } from "configs/httpStatus";
import { fetchDestinationData } from "services/bodyTemperature";

import { handleSuccesAction, handleErrorAction } from "./destinationActions";

function* getDataDestinationSaga({ payload }: { payload: { locale: string } }) {
  try {
    const response: DataDestinationResponse = yield call(
      fetchDestinationData,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetDataDestinationWatcher() {
  yield takeLatest(ActionType.DATA_DESTINATION as any, getDataDestinationSaga);
}

export default [fork(onGetDataDestinationWatcher)];
